import React from "react";
import classNames from "classnames";
import ProductsResults from "../ProductsResults";
import CategoriesResults from "../CategoriesResults";
import PagesResults from "../PagesResults";
import Stack from "theme/components/atoms/Layout/Stack";
import Link from "theme/components/atoms/Typography/Link";
import SearchBarResultsEmpty from "./SearchBarResultsEmpty";
import { FormattedMessage } from "react-intl";
import SearchBarResultsLoading from "./SearchBarResultsEmptyLoading";
import SearchBarResultsError from "./SearchBarResultsEmptyError";
import { useAutocompleteOption } from "theme/components/organisms/Autocomplete/useAutocomplete";
import QueriesResults from "../QueriesResults";

const hasResults = ({ queries, products, categories, pages }) =>
  queries.length > 0 ||
  products.length > 0 ||
  categories.length > 0 ||
  pages.length > 0;

const SearchBarResults = (props) => {
  const isEmpty = !props.results || !hasResults(props.results);

  const [isAllSelected, allAutocompleteProps] = useAutocompleteOption(
    "all",
    props.searchUrl,
    props.selected,
    props.onSelect
  );

  if (props.loading && isEmpty) {
    return <SearchBarResultsLoading />;
  }
  if (props.error) {
    return <SearchBarResultsError />;
  }
  if (isEmpty) {
    return <SearchBarResultsEmpty />;
  }

  const hasQueries = props.results.queries.length > 0;
  const hasProducts = props.results.products.length > 0;
  const hasCategories = props.results.categories.length > 0;
  const hasPages = props.results.pages.length > 0;

  return (
    <div
      className={classNames("searchbar-results", {
        "searchbar-results--two-columns":
          hasProducts && (hasCategories || hasPages),
      })}
    >
      <Stack size="2">
        <div className="searchbar-results__results">
          {hasQueries && (
            <div key="queries" className="searchbar-results__element">
              <QueriesResults
                results={props.results.queries}
                selected={props.selected}
                onSelect={props.onSelect}
                onQuerySelect={props.onQuerySelect}
              />
            </div>
          )}
          {hasProducts && (
            <div key="products" className="searchbar-results__element">
              <ProductsResults
                results={props.results.products}
                selected={props.selected}
                onSelect={props.onSelect}
              />
            </div>
          )}
          {(hasCategories || hasPages) && (
            <div key="categories-pages" className="searchbar-results__element">
              <Stack size="2" mobileSize="4">
                {hasCategories && (
                  <CategoriesResults
                    key="categories"
                    results={props.results.categories}
                    selected={props.selected}
                    onSelect={props.onSelect}
                  />
                )}
                {hasPages && (
                  <PagesResults
                    key="pages"
                    results={props.results.pages}
                    selected={props.selected}
                    onSelect={props.onSelect}
                  />
                )}
              </Stack>
            </div>
          )}
        </div>
        <div className="center">
          <span {...allAutocompleteProps}>
            <Link
              buttonAppearance={isAllSelected ? "primary" : "default"}
              to={props.searchUrl}
            >
              <FormattedMessage
                id="modules.Search.SearchBar.SearchBarResults.viewAll"
                defaultMessage="See all results"
              />
            </Link>
          </span>
        </div>
      </Stack>
    </div>
  );
};

export default SearchBarResults;
